
<div>
  <div class="ads-container">
    <div class="shadow-sm ads px-4 py-1 d-flex justify-content-between align-items-center" *ngFor="let a of announcements">
        <div class="me-2 text-ad-title fw-semibold text-uppercase">
          <mat-icon class="me-2">notification_important</mat-icon>  
          <span>{{a.announcementText}}</span> 
        </div>
        <a class="badge bg-primary ms-2 text-uppercase border-pill ads-btn" style="text-decoration: none !important; cursor: pointer !important;" (click)="hideAnnouncementsByCustomer(a.id)">
          <mat-icon>close</mat-icon></a>
    </div>
  </div>
  <main class="container-lg d-flex justify-content-center align-items-center my-3"  style="min-height: 70vh;">
    <header class="d-flex flex-column justify-content-center">
      <h1 *ngIf="this.customerStatus == 2; else WelcomeMessage">Gracias por tu interés en formar parte de Aliwell.</h1>
      <ng-template #WelcomeMessage>
        <h1 >Bienvenido a Aliwell<sup>&#174;</sup></h1>
      </ng-template>

      <div class="mb-2">
        <app-orders-list-home *ngIf="this.customerStatus == 1"></app-orders-list-home>
      </div>

      <div *ngIf="this.customerStatus == 1">
        <app-case-list-home></app-case-list-home>
      </div>

      <ng-container #pending *ngIf="this.customerStatus == 2" >
        <h5 class="text-center">Actualmente contamos con una lista de espera de aproximadamente 3 meses para la aprobación de nuevas cuentas, debido a la alta demanda.</h5>
        <h5 class="text-center">Agradecemos tu confianza y esperamos colaborar contigo muy pronto.</h5>
        <h6 class="text-center">Contáctanos</h6>
        <div class="w-100 d-flex">
          <a class="mx-auto" href="https://api.whatsapp.com/send?phone=+5218186834840&text=Hola,%20me%20acabo%20de%20registrar%20y%20quisiera%20dar%20seguimiento%20a%20la%20activaci%C3%B3n%20de%20mi%20cuenta." target="_blank" title="Whatsapp">
            <i class="fa fa-whatsapp" style="font-size: 3em;"></i>
          </a>
        </div>
      </ng-container>

      <ng-container *ngIf="this.customerStatus == -1">
        <app-loading></app-loading>
      </ng-container>
    </header>
  </main>
</div>
